import { setContext } from "@apollo/client/link/context";
import { getAccessToken, isTokenValid } from "@/lib/tokenManager";

export const authLink = setContext(async (_, { headers = {}, ...rest }) => {
  let authToken: string | null = null;

  if (typeof window !== "undefined") {
    authToken = getAccessToken();

    if (authToken && !isTokenValid(authToken)) {
      console.warn("[authLink] Access token expired");
      authToken = null;
    }

    // Defense in depth: Strip "Bearer " prefix if it's already there
    // Tokens should never be stored with the prefix, but handle it gracefully
    if (authToken?.startsWith("Bearer ")) {
      console.warn("[authLink] Token already has Bearer prefix, stripping it");
      authToken = authToken.replace("Bearer ", "");
    }
  }

  const authHeaders: Record<string, string> = authToken ? { Authorization: `Bearer ${authToken}` } : {};

  return {
    ...rest,
    headers: {
      ...headers,
      ...authHeaders,
    },
  };
});
